import { View } from "binder"
import { SetReceiptBillsPriceViewModel } from "./setReceiptBillsPrice-viewModel"
import { WarehouseSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";

export class SetReceiptBillsPriceView extends View<SetReceiptBillsPriceViewModel>{
    GetViewUniqueId(): string {
        return "V-DD65494D-B5AE-4CC4-AD6C-913EFF790023"
    }
    loadHtml(): string {
        let element = require('./setReceiptBillsPrice.html').default;
        let style = require('./setReceiptBillsPrice.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    // public set warehouseSelector(v: WarehouseSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelectorViewModel;
    // public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set billNoFrom(v: number) { this._billNoFrom = v; } public get billNoFrom(): number { return this._billNoFrom; } private _billNoFrom: number;
    public set billNoUntil(v: number) { this._billNoUntil = v; } public get billNoUntil(): number { return this._billNoUntil; } private _billNoUntil: number;

    confirm() {
        this.dataContext.confirm();
    }

    back() {
        this.dataContext.back();
    }
}
